<template>
    <comp-9-prep-adherence :section="9" :page="17" :next="nextScreen" :nextDisabled="nextDisabled">
        <p class="caption font-weight-bold mb-1 input-label">
            What type of PrEP have you taken most recently?
        </p>
        <v-radio-group v-model="prepTypeSelection" column>
            <v-radio v-for="type in prepTypes" :key="type.id" :label="type.text" :value="type"></v-radio>
        </v-radio-group>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            prepTypeSelection: null
        };
    },
    computed: {
        prepType() {
            let selectedPrepType = find(this.prepTypes, 'selected');

            if (selectedPrepType) {
                return selectedPrepType;
            } else return null;
        },
        prepTypes: sync('section9/prepTypes'),
        nextScreen() {
            if (this.prepTypeSelection) {
                return `/page/9/${this.prepTypeSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.prepTypeSelection;
        }
    },
    watch: {
        prepTypeSelection(newPrepTypeSelection) {
            forEach(this.prepTypes, o => {
                if (o.id === newPrepTypeSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.prepTypeSelection = this.prepType;
    }
};
</script>
